import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import React from "react";
import { connect } from "react-redux";
import { removeFromBasket } from "../../services/basket/actions";

function removeFromBasketButton(props) {
  return (
    <div>
      <Button
        color="primary"
        onClick={() => {
          props.removeFromBasket(
            props.currentLocation.id,
            props.basketItem,
            props.basketProducts
          );
        }}
      >
        <DeleteIcon />
      </Button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  basketProducts: state.basket.products,
});

export default connect(mapStateToProps, {
  removeFromBasket,
})(removeFromBasketButton);
